import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import rootSaga from '../sagas';
import RootReducer from '../reducers';
const sagaMiddleware = createSagaMiddleware();
// Manually type the middleware array
const middleware = [sagaMiddleware];
if (process.env.NODE_ENV === 'development') {
    middleware.push(logger); // <-- fix the type here
}
// Setup Redux DevTools compose
const composeEnhancers = (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
// Create the store
const store = createStore(RootReducer, composeEnhancers(applyMiddleware(...middleware)));
// Run the root saga
sagaMiddleware.run(rootSaga);
export default store;
